import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

// The site ids can be a long list, so this endpoint is a POST with a body
// instead of a GET with parameters in the url (an url has a size limit).
// The body is { siteIds, fileLocation, planName } and matches TrxReductionRequest in the API.
export const GenerateTrxReductionRequest = (request) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}TrxReduction/GenerateTrxInfo`,
	data: request
});
